import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'environments/environment';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {
  GroupSchedulesRequest,
  MenuSchedule,
  MenuScheduleChangeRequestItem,
  MenuScheduleResponseItem, MenuSchedulesResponse, ProductSchedulesRequest,
} from 'app/models/menu.schedule.model';
import { IBaseResponse } from 'app/models/baseResponse.model';

@Injectable({
  providedIn: 'root'
})
export class MenuScheduleApiService {
  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(private http: HttpClient) {
  }

  public async getSchedules(menuSectionId: string): Promise<IBaseResponse<MenuScheduleResponseItem[]>> {
    const url = environment.posBaseUrl + `/api/front/menu_schedules/${menuSectionId}`;
    try {
      return await firstValueFrom(this.http.get<IBaseResponse<MenuSchedule[]>>(url));
    }
    catch (exception){
      console.log('exception', exception);
    }
  }

  // return all schedules
  public async changeSchedules(request: MenuScheduleChangeRequestItem[]):
    Promise<IBaseResponse<MenuScheduleResponseItem[]>>
  {
    const url = environment.posBaseUrl + '/api/front/menu_schedules/change';
    try {
      return await firstValueFrom(this.http.post<IBaseResponse<any>>(
        url,
        request,
        { headers: this.headers }));
    }
    catch (exception){
      console.log('exception', exception);
      return {
        success: false,
        data: null,
        errors: [{
          code: '',
          message: exception.message,
        }]
      }
    }
  }

  async getProductSchedules(menuSectionId: string, externalProductId: string):
    Promise<IBaseResponse<MenuSchedulesResponse>>
  {
    const url = environment.posBaseUrl + `/api/front/menu_schedules/${menuSectionId}/product/${externalProductId}/`;
    try {
      return await firstValueFrom(this.http.get<IBaseResponse<MenuSchedulesResponse>>(url));
    }
    catch (exception){
      console.log('exception', exception);
    }
  }

  async getGroupSchedules(menuSectionId: string, groupId: string):
    Promise<IBaseResponse<MenuSchedulesResponse>>
  {
    const url = environment.posBaseUrl + `/api/front/menu_schedules/${menuSectionId}/group/${groupId}/`;
    try {
      return await firstValueFrom(this.http.get<IBaseResponse<MenuSchedulesResponse>>(url));
    }
    catch (exception){
      console.log('exception', exception);
    }
  }

  public async setProductSchedules(request: ProductSchedulesRequest)
  {
    const url = environment.posBaseUrl + '/api/front/menu_schedules/product';
    try {
      return await firstValueFrom(this.http.post<IBaseResponse<any>>(
        url,
        request,
        { headers: this.headers }));
    }
    catch (exception){
      console.log('exception', exception);
      return {
        success: false,
        data: null,
        errors: [{
          code: '',
          message: exception.message,
        }]
      }
    }
  }

  public async setGroupSchedules(request: GroupSchedulesRequest)
  {
    const url = environment.posBaseUrl + '/api/front/menu_schedules/group';
    try {
      return await firstValueFrom(this.http.post<IBaseResponse<any>>(
        url,
        request,
        { headers: this.headers }));
    }
    catch (exception){
      console.log('exception', exception);
      return {
        success: false,
        data: null,
        errors: [{
          code: '',
          message: exception.message,
        }]
      }
    }
  }
}
